import React from 'react';

import { Box, Paper, Skeleton, Typography } from '@mui/material';

import { SxProp } from 'src/types/mui';

import { ActiveBillingRateItemType } from './types';

export type ActiveBillingRateItemProps = ActiveBillingRateItemType;

export const ActiveBillingRateItem: React.FC<ActiveBillingRateItemProps> = ({
  title,
  value,
  loading,
  ...restProps
}) => {
  return (
    <Paper sx={paperStyles} variant="outlined">
      <Typography variant="body2" noWrap>
        {title}
      </Typography>
      <Typography fontWeight="bold" variant="h4">
        {loading ? <Skeleton width={50} /> : `$${value}`}
      </Typography>

      <Box>
        {restProps.description && (
          <Typography
            component="span"
            variant="body2"
            sx={{ color: restProps.color || (theme => theme.palette.text.secondary) }}
          >
            {loading ? <Skeleton width={200} /> : restProps.description}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

const paperStyles: SxProp = {
  px: 3,
  py: 2,
  borderRadius: 2,
  flexBasis: 0,
  flexGrow: 1,
  minWidth: 250,
  gap: 0.5,
  display: 'flex',
  flexDirection: 'column',
};
